import DashboardArea from "@/src/components/buckeye-coordinator-area/DashboardArea.vue";
import PluginDashboard from "@/src/components/buckeye-coordinator-area/dashboards/PluginDashboard.vue";
import InternalQADashboard from "@/src/components/buckeye-coordinator-area/dashboards/InternalQADashboard.vue";
import UnfinishedBusinessDashboard from "@/src/components/buckeye-coordinator-area/dashboards/UnfinishedBusinessDashboard.vue";
import ManageOffer from "@/src/components/buckeye-coordinator-area/manual_offers/ManageOffer.vue";
import EditInstance from "@/src/components/buckeye-coordinator-area/plugin_templates/EditInstance.vue";
import MatchInstances from "@/src/components/buckeye-coordinator-area/plugin_templates/MatchInstances.vue";
import {PermissionNames} from "@/src/enums";
import SuperTeamDashboard from '@/src/components/buckeye-coordinator-area/dashboards/super-teams/Dashboard.vue';
import MatchArea from "@/src/components/buckeye-coordinator-area/match/MatchArea.vue";
import ChecklistDashboard from "@/src/components/buckeye-coordinator-area/match/checklist/ChecklistDashboard.vue";
import ChecklistPrintPreview from "@/src/components/buckeye-coordinator-area/match/checklist/ChecklistPrintPreview.vue";

import CommsTemplatesIndex from "@/src/components/buckeye-coordinator-area/match/comms_templates/CommsTemplateIndex.vue";

export const internalRoutes = [
  {
    path: 'internal',
    children: [
      {
        path: 'dashboards',
        children: [
          {
            path: '',
            name: 'internal-dashboards-root',
            component: DashboardArea,
            meta: {
              permissions: ['area_internal']
            }
          },
          {
            path: 'qa-dashboard',
            name: 'internal-dashboard-internal-qa',
            component: InternalQADashboard,
            meta: {
              permissions: [PermissionNames.INTERNAL_DASHBOARD_INTERNAL_QA]
            }
          },
          {
            path: 'plugin', // Add redirect url for plugin, so bookmarked plugin url goes to the new url.
            redirect: () => {
              return { name: 'internal-dashboard-plugin' };
            }
          },
          {
            path: 'coordinator',
            name: 'internal-dashboard-plugin',
            component: PluginDashboard,
            meta: {
              permissions: ['internal_dashboard_plugin']
            }
          },
          {
            path: 'unfinished-business',
            name: 'internal-dashboard-unfinished-business',
            component: UnfinishedBusinessDashboard,
            meta: {
              permission: ['internal_dashboard_unfinished_business']
            }
          },
          {
            path: 'super-teams',
            children: [
              {
                path: '',
                name: 'internal-dashboard-super-teams',
                components: {
                  default: SuperTeamDashboard,
                },
                meta: {
                  permissions: ['internal_dashboard_internal_super_teams']
                }
              },
              {
                path: ':id',
                name: 'internal-dashboard-super-teams_edit',
                components: {
                  default: SuperTeamDashboard,
                },
                meta: {
                  permissions: ['internal_dashboard_internal_super_teams']
                }
              }
            ]
          },
        ]
      },
      {
        path: 'offers',
        name: 'manage-offer',
        component: ManageOffer,
        meta: {
          permissions: ['area_internal']
        }
      },
      {
        path: 'instances',
        component: MatchArea,
        children: [ 
          {
            path: 'edit-instance/:donor/:match/:txc/:organGroup/:instanceId',
            name: 'edit-instance',
            components: {
              default: EditInstance,
            },
            meta: {
              permissions: ['area_internal']
            },
            props: true
          },
          {
            path: 'match-instances',
            name: 'match-instances',
            components: {
              default: MatchInstances,
            },
            meta: {
              permissions: ['area_internal']
            },
            props: true
          },
        ]
      },
      {
        path: 'matches/:match_id/checklists/print',
        component: ChecklistPrintPreview,
        name: 'internal-match-checklist-print',
        meta: {
          permissions: ['internal_match_checklists'],
          bareLayout: true
        }
      },
      {
        path: 'matches',
        component: MatchArea,
        children: [
          {
            path: ':match_id',
            children: [
              {
                path: 'checklists',
                component: ChecklistDashboard,
                name: 'internal-match-checklists',
                meta: {
                  permissions: ['internal_match_checklists']
                }
              },
              {
                path: 'comms-templates',
                component: CommsTemplatesIndex,
                name: 'internal-match-comms-templates',
                meta: {
                  permissions: ['internal_match_communication_templates']
                }
              }
            ]
          }  
        ]
      }
    ]
  }
]
